import { useEffect, useRef } from "react";
import { PuzzleResultsSharing } from "@/components/PuzzleResultsSharing";
import "./VictoryCelebration.css";

export function VictoryCelebration({ celebration, onDismiss, shareResult, playId }) {
  const close = useRef(null);
  const dialog = useRef(null);
  useEffect(() => {
    const previous = document.activeElement;
    close.current?.focus();
    const key = event => {
      if (event.key === "Escape") onDismiss();
      if (event.key === "Tab") {
        const controls = [...dialog.current.querySelectorAll('button:not(:disabled), a[href], textarea, input')];
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && (document.activeElement === first || !dialog.current.contains(document.activeElement))) {
          event.preventDefault(); last?.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !dialog.current.contains(document.activeElement))) {
          event.preventDefault(); first?.focus();
        }
      }
    };
    document.addEventListener("keydown", key);
    return () => {
      document.removeEventListener("keydown", key);
      if (previous?.isConnected) previous.focus();
    };
  }, [onDismiss]);
  return (
    <div className="hhkd-victory" data-testid="victory-overlay" onClick={event => { if (event.target === event.currentTarget) onDismiss(); }}>
      <section ref={dialog} className="hhkd-victory-card" role="dialog" aria-modal="true" aria-labelledby="victory-title" aria-describedby="victory-message">
        <div className="hhkd-victory-lights" aria-hidden="true">
          {Array.from({ length: 24 }, (_, i) => <i key={i} style={{ "--i": i }} />)}
        </div>
        <div className="hhkd-victory-particles" aria-hidden="true">
          {Array.from({ length: 32 }, (_, i) => <i key={i} style={{ "--x": `${(i * 37) % 100}%`, "--drift": `${(i % 2 ? 1 : -1) * (30 + i * 3)}px`, "--delay": `${(i % 8) * 0.035}s`, "--color": ["#ffd45a", "#ff48d1", "#63f8ff"][i % 3] }} />)}
        </div>
        <p className="hhkd-victory-kicker">HIP HOP KNOWLEDGE DROP</p>
        <h2 id="victory-title">PUZZLE<br />SOLVED!</h2>
        <p id="victory-message" className="hhkd-victory-message">{celebration.message}</p>
        <p className="hhkd-victory-score"><strong>{celebration.score}</strong> POINTS</p>
        {shareResult && <PuzzleResultsSharing result={shareResult} playId={playId} />}
        <button ref={close} type="button" onClick={onDismiss} data-testid="victory-dismiss">Back to the grid</button>
      </section>
    </div>
  );
}
